import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DialogShared {
  constructor() {}

  private acceptButtonClickObs = new BehaviorSubject<boolean>(false);
  acceptButtonClickObs$ = this.acceptButtonClickObs.asObservable();

  private addFoodContinueButtonClickObs = new BehaviorSubject<boolean>(false);
  addFoodContinueButtonClickObs$ =
    this.addFoodContinueButtonClickObs.asObservable();

  private removeFoodContinueButtonClickObs = new BehaviorSubject<boolean>(
    false
  );
  removeFoodContinueButtonClickObs$ =
    this.removeFoodContinueButtonClickObs.asObservable();

  private editFoodContinueButtonClickObs = new BehaviorSubject<boolean>(false);
  editFoodContinueButtonClickObs$ =
    this.editFoodContinueButtonClickObs.asObservable();

  private changePlanClickObs = new BehaviorSubject<boolean>(false);
  changePlanClickObs$ = this.changePlanClickObs.asObservable();

  acceptButtonClick() {
    this.acceptButtonClickObs.next(true);
    this.acceptButtonClickObs.next(false);
  }

  addFoodContinueButtonClick() {
    this.addFoodContinueButtonClickObs.next(true);
    this.addFoodContinueButtonClickObs.next(false);
  }

  removeFoodContinueButtonClick() {
    this.removeFoodContinueButtonClickObs.next(true);
    this.removeFoodContinueButtonClickObs.next(false);
  }

  editFoodContinueButtonClick() {
    this.editFoodContinueButtonClickObs.next(true);
    this.editFoodContinueButtonClickObs.next(false);
  }

  changePlanClick() {
    this.changePlanClickObs.next(true);
    this.changePlanClickObs.next(false);
  }
}
